import React from "react";
import "./ProcessFlowContent.css";
import mailData from "../Data/mailData.js";

function ProcessFlowContent() {
  return (
    <>
      <div className="main-banner">
        <img
          src={
            process.env.PUBLIC_URL +
            "/images/ProcessFlow/Process-Flow-banner.png"
          }
          alt="Banner"
          className="banner-img"
        />
        <div className="banner-content">
          <h1>Process Flow</h1>
          {/* <p><i>Lorem ipsum is simply dummy text of the printing</i></p> */}
        </div>
      </div>
      {/* Hanging menu  */}
      <div className="icons-container">
        <div className="icons-wrap">
          <div className="icons-row row1">
            <div className="icons-box">
              <div className="img-link">
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/contact_icon.png"}
                  alt="Mailicon"
                  className="group-img mailIcon"
                  id="icon-chat"
                />
                <a
                  className="contact-us"
                  target="_blank"
                  href={`mailto: ${mailData.dellearningframework}`}
                >
                  <span className="menu-text">Write to us</span>
                </a>
                {/* <span className="contact-word">Mail</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flow-container">
        <div className="flow-wrap">
          {/* <h1>LKM Process</h1> */}
          <p>
            Key Processes across different Phases of the Learning Life Cycle
            within L&TT, ATCI.
          </p>
          <div className="flow-row">
            <img
              src="/images/ProcessFlow/L&TT Process Flow Ver 1.6.jpg"
              alt="process-flow"
            />
          </div>
        </div>
      </div>

      <div className="link_container_below">
        <div className="link_cont_wrap">
          <div>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/Home/Acc_GT_Dimensional_RGB.png"
              }
              alt="AccentureIcon"
              className="link_accenture_logo"
            />
          </div>
          <div className="link_text_cont">
            <span>
              For any queries or support, you may reach out to
              <a
                className="link_anchor"
                href={`mailto:${mailData.qualityassurance}`}
                target="_blank"
              >
                {" "}
                {mailData.qualityassurance}{" "}
              </a>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProcessFlowContent;
